import { Component, OnInit } from '@angular/core';
import { MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';

@Component({
  selector: 'neoris-dialog-incident-close',
  templateUrl: './dialog-incident-close.component.html',
  styleUrls: ['./dialog-incident-close.component.css']
})
export class DialogIncidentCloseComponent  {

  constructor(public dialogRef: MatDialogRef<DialogIncidentCloseComponent>,
    private propertiesService:PropertiesTowers) { }


  close(){
    this.dialogRef.close()
  }

  save(){
    this.propertiesService.setClickBtnFormIncident(2) //
    this.dialogRef.close()
  }

}
